<div class="h-screen">
  <router-outlet />
</div>

<!-- Toast global (notificaciones de cualquier módulo) -->
<p-toast position="top-right" />

<!-- Barra flotante de progreso Utilidades Montos — v2 -->
@if (utilProgress.isActive() || utilProgress.isCompleted() || utilProgress.isPartiallyCompleted()) {
  @if (!utilProgress.floatingBarDismissed()) {
    <div class="util-floating-bar">
      <div class="util-floating-header">
        @if (utilProgress.isCompleted()) {
          <i class="pi pi-check-circle" style="color: #16a34a;"></i>
        } @else if (utilProgress.isPartiallyCompleted()) {
          <i class="pi pi-exclamation-triangle" style="color: #d97706;"></i>
        } @else {
          <i class="pi pi-spin pi-spinner"></i>
        }

        <span>{{ utilProgress.statusMessage() }}</span>

        <button class="util-close-btn" (click)="utilProgress.dismiss()" title="Cerrar">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Indeterminate durante dispatch (zona muerta), determinate con progreso real -->
      @if (utilProgress.showIndeterminate()) {
        <p-progressBar mode="indeterminate" styleClass="util-float-pbar" />
      } @else {
        <p-progressBar
          [value]="utilProgress.progress()"
          [showValue]="false"
          styleClass="util-float-pbar"
        />
      }

      <span class="util-floating-pct">
        @if (utilProgress.progress() > 0 && utilProgress.progress() < 100) {
          {{ utilProgress.progress() | number:'1.0-0' }}%
          @if (utilProgress.procesadas() > 0) {
            &nbsp;— {{ utilProgress.procesadas() }}/{{ utilProgress.totalFilas() }} reg
          }
          @if (utilProgress.velocidad(); as v) {
            &nbsp;({{ v | number:'1.1-1' }} reg/s)
          }
          @if (utilProgress.eta(); as eta) {
            &nbsp;— ~{{ eta < 60 ? (eta | number:'1.0-0') + 's' : (eta/60 | number:'1.0-0') + ' min' }}
          }
        }
      </span>
    </div>
  }
}

<!-- Barra flotante de progreso CTS -->
@if (ctsProgress.isActive()) {
  <div class="cts-floating-bar">
    <div class="cts-floating-header">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Cargando archivos CTS...</span>
      <button class="cts-close-btn" (click)="ctsProgress.dismiss()" title="Cerrar">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <p-progressBar
      [value]="ctsProgress.progress()"
      [showValue]="false"
      styleClass="cts-float-pbar"
    />
    <span class="cts-floating-pct">{{ ctsProgress.progress() }}% completado</span>
  </div>
}
